import type { DocumentsResources } from '../en/documents';

export const documents: DocumentsResources = {};
